export const UploadConstants = {
  ONE_MB: 1000000,
  MAX_SIZE: 1048576 * 20 ,
  MAX_SIZE_STRING: "20 MB",
}
